import { Link } from 'react-router-dom';
import { Building2, Mail, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-card/50 border-t border-border/20 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="font-playfair text-2xl font-bold text-gold-gradient">Patina</span>
              <span className="font-manrope text-sm text-muted-foreground tracking-widest uppercase">Mart</span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-md mb-6">
              The premier marketplace for salvaged and reclaimed building materials.
              <br />
              Connecting architects, designers, and contractors with sustainable resources.
            </p>
            <a
              href="/revit"
              className="inline-flex items-center gap-2 text-muted-foreground hover:text-accent transition-colors group"
              data-testid="footer-revit-download-link"
            >
              <Building2 className="w-5 h-5" />
              <span className="text-sm group-hover:underline">Download Revit Plugin →</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-lg font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/marketplace" className="text-sm text-muted-foreground hover:text-accent transition-colors">
                  Browse Materials
                </Link>
              </li>
              <li>
                <Link to="/auth?mode=register&type=supplier" className="text-sm text-muted-foreground hover:text-accent transition-colors">
                  Become a Supplier
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-sm text-muted-foreground hover:text-accent transition-colors">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/trust" className="text-sm text-muted-foreground hover:text-accent transition-colors" data-testid="footer-trust-link">
                  Trust &amp; verification
                </Link>
              </li>
              <li>
                <Link to="/supplier-app" className="text-sm text-muted-foreground hover:text-accent transition-colors">
                  Supplier Wingman app
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-playfair text-lg font-semibold text-foreground mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Mail className="w-4 h-4" />
                <span>contact@patinamart.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Phone className="w-4 h-4" />
                <span>+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4" />
                <span>Global Marketplace</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border/20 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} PatinaMart. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Privacy</a>
            <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Terms</a>
            <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">API</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
